/**
 * Lightweight singleton registry that maps appId -> taskbar button DOM element.
 * Used by AppWindow to measure the taskbar button position for minimize/restore animations.
 */

const elements = new Map<string, HTMLElement>()

export const taskbarButtonRegistry = {
  register(appId: string, el: HTMLElement | null) {
    if (el) elements.set(appId, el)
    else elements.delete(appId)
  },

  measure(appId: string): DOMRect | undefined {
    return elements.get(appId)?.getBoundingClientRect()
  },
}
